export default __webpack_public_path__ + "static/media/plinko.aff36762.png";